export default function getStraightLine(
    fromLngLat: mapboxgl.LngLat,
    toLngLat: mapboxgl.LngLat
): GeoJSON.LineString {
    return {
        type: 'LineString',
        coordinates: [fromLngLat.toArray(), toLngLat.toArray()],
    };
}
